<template>
  <div class="accordion-container">
    <v-expansion-panels v-model="accordion" multiple flat>
      <v-expansion-panel
        v-for="(item, index) in content"
        :key="index"
        class="mb-4 mt-0"
      >
        <v-expansion-panel-header class="accordion-header">{{
          item.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="accordion-content">
          <div v-html="item.value" class="ck-content" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'Accordion',
  props: ['model'],
  computed: {
    content: function () {
      return this.model.content
    }
  },
  data: () => ({
    accordion: []
  })
}
</script>
<style lang="scss" scoped>
.accordion-header {
  font-size: 2rem;
}
.accordion-content {
  font-size: 1.6rem;
}
</style>
